module.exports = __webpack_public_path__ + "img/bg_unified_meal.730ba80e.png";